import {
    Button
} from 'shared/components/ui/button';
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger
} from 'shared/components/ui/dropdown-menu';
import {
    EllipsisVertical
} from 'lucide-react';

/**
 * @typedef {Object} DropdownItem
 * @property {string} label The text displayed in the frontend.
 * @property {import("react").ReactSVG} icon The icon of the item
 * @property {Function} action The function that would execute when clicked
 */
/**
 *
 * @param {Object} props
 * @param {number} props.iconSize The icon size of the menu icon.
 * @param {DropdownItem[]} props.items The array of items to be displayed.
 * @returns {import("react").ReactNode}
 */
export default function MenuPopover({
    iconSize = 15, items,
}) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button variant="ghost" className="p-2 relative">
                    <EllipsisVertical size={iconSize}/>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent >
                {items?.map((item)=>(
                    <DropdownMenuItem className="h-8 gap-2 data-[highlighted]:bg-neutral-100" onSelect={()=>item.action()}>
                        {item.icon}
                        {item.label}
                    </DropdownMenuItem>
                ))}
                {!items?.length && <span className="text-black text-xs">No items to show.</span>}
            </DropdownMenuContent>
        </DropdownMenu>

    );
}